module.exports = __webpack_public_path__ + "static/media/centa-logo-new.0b71d6dc.png";